import { Component, input, output } from '@angular/core';
import { ButtonSize } from '@ui';
import { ButtonComponent } from '../button/button.component';

@Component({
  standalone: true,
  selector: 'ui-close',
  templateUrl: './close.component.html',
  imports: [ButtonComponent],
})
export class CloseComponent {
  readonly border = input<boolean>(false);
  readonly size = input<ButtonSize>('sm');
  readonly isDarkMode = input<boolean>(false);
  readonly onClick = output<void>();
}
